import "preact/debug"
import { html } from "htm/preact";

import { ElfsightPopup } from "../src/utils/fw"
import render from "../src/index"
import lobby from "./lobby"
import lounge from "./lounge"
import { NavBar } from "./Navbar";


export const rooms = [
    lobby, lounge
]


export const extras = html`<script src="https://apps.elfsight.com/p/platform.js" defer><//>`
export const afterRoom = html`<${ElfsightPopup} ID="ea606ac0-833a-4e9a-82fc-75b4c915a16c" trigger="2021-sept-TIFF-welcome-popup" />`

render(rooms, { beforeRoom: html`<${NavBar} />` }, { extras }, { afterRoom: html`<${ElfsightPopup} ID="ea606ac0-833a-4e9a-82fc-75b4c915a16c" trigger="2021-sept-TIFF-welcome-popup" />` })